<template>
    <div class="d-flex w-100 flex-grow-1" v-if="loaded">
        <!-- <header-content :files="files" :title="$t('content.lesson.video_n')"></header-content> -->
        <div class="col-12 mx-0 px-0 d-flex flex-column">
            <div class="d-flex px-0">
                <div class="d-flex w-100 px-0">
                    <component
                        v-model="video"
                        :video="video"
                        :contentId="contentId"
                        :lessonId="lessonId"
                        :is="typeVideo"
                        @progress="$emit('progress', $event)"
                        @liveSettings="$emit('liveSettings', $event)"
                    />
                </div>
            </div>
            <!-- Seção inferior também no acesso anônimo (backlog#410): Visão
                 Geral e Material de apoio (downloads assinados); o Fórum fica
                 restrito a usuários logados (TabOptions trata via isPublic). -->
            <TabOptions :lesson="lesson" :is-public="isPublic"/>
        </div>
    </div>
</template>

<script>

import OD from './LessonContentVideo/ContentOnDemand.vue';
import LV from './LessonContentVideo/ContentLive.vue';
import VC from './LessonContentVideo/ContentConference.vue';
import HeaderContent from './LessonContentComponents/LessonContentHeader.vue';
// import ContentSideBar from '../ContentComponents/ContentSideBar.vue'; // Removido pois não está sendo usado
import TabOptions from '../Common/TabOptions/TabOptions.vue';
import EVT from './LessonContentVideo/ContentEvt.vue';

export default {
    emits: ['input', 'liveSettings', 'progress', 'side', 'update:modelValue'],
    name: 'LessonContentVideo',
    components: {
        OD,
        LV,
        VC,
        HeaderContent,
        TabOptions,
        EVT,
    },
    data() {
        return {
            tab: null,
            loaded: false,
            files: [],
        };
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({
                id: 0,
                hash: '',
                secret: '',
                progress: null,
                time: null,
            }),
        },
        user: Object,
        rightBar: Boolean,
        contentId: {
            type: Number,
            required: true,
        },
        lesson: Object,
        lessonId: {
            type: Number,
            required: true,
        },
        isPublic: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        video: {
            handler(newVideo) {
                if (newVideo) {
                    this.showChat(newVideo);
                }
            },
            deep: true,
            immediate: false,
        },
        contentId(newVal) {
            this.getContent(newVal);
        },
        rightBar(value) {
            this.tab = value ? null : this.tab;
        },
    },
    computed: {
        video: {
            get() {
                return this.modelValue;
            },
            set(video) {
                this.$emit('update:modelValue', video);
                this.$emit('input', video);
            },
        },
        language() {
            return this.$store.getters.LANGUAGE;
        },
        typeVideo() {
            if (this.video.type_video === 'OD') {
                return 'OD';
            } else if (this.video.type_video === 'NCH_VC') {
                return 'VC';
            } else if (this.video.type_video === 'EVT') {
                return 'EVT';
            }
            return 'LV';
        },
    },
    methods: {
        getContent(contentId) {
            // Primeiro, verificar se temos URLs assinadas no localStorage para este conteúdo
            const signedUrls = localStorage.getItem(`content_${contentId}_download_urls`);

            // Se estamos em uma aula pública ou plano público, tentamos usar a URL assinada primeiro
            if ((this.lesson.public || window.location.pathname.includes('/app/public/') || this.isPublic) && signedUrls) {
                this.$loading.show();

                // Usar a rota normal com o parâmetro lessonPublic=true
                return window.axios
                    .get(`/api/app/lesson/${this.lessonId}/content/${this.contentId}/public`)
                    .then((res) => {
                        this.video = res.data;
                        this.loaded = true;
                        this.showChat(res.data);
                    })
                    .catch(err => console.error(err))
                    .finally(() => {
                        this.$loading.close();
                    });
            }

            const publicContent = (this.lesson.public || this.isPublic) ? '/public' : '';
            this.$loading.show();

            // Verifica se a aula ou plano é público e caso seja, chama a rota pública
            return window.axios
                .get(`/api/app/lesson/${this.lessonId}/content/${contentId}${publicContent}`, {
                    params: {
                        lessonPublic: !!(this.lesson.public || this.isPublic),
                    },
                })
                .then((res) => {
                    this.video = res.data;
                    this.loaded = true;
                    this.showChat(res.data);
                })
                .catch(err => console.error(err))
                .finally(() => {
                    this.$loading.close();
                });
        },
        showChat(video) {
            // chat é exibido quando ao vivo ou configurado para exibir pós live (ondemand)
            const value = video && video.settings && video.settings.chat
                && (video.settings.chat_show || video.settings.live);

            // emite valor alterado para sidebar
            this.$emit('side', { component: 'ChatLive', value: !!value, data: video.settings });
        },
        changeTab() {
            const data = this.tab == 3
                ? { component: 'ChatLive', value: this.showChat, data: this.video.settings }
                : { component: 'ChatLive', value: false, data: this.video.settings };

            this.$emit('side', data);
        },
    },
    beforeMount() {
        const chat = document.getElementById('support-chat');
        if (chat) {
            chat.style.display = 'none';
        }
    },
    mounted() {
        this.getContent(this.contentId);
    },
};
</script>
